const email = document.getElementById('email');
email?.addEventListener ('blur', async (event) => {
    const corporationSection = document.getElementById('registration__corporation');

    if (corporationSection === null) {
        return;
    }

    const companyName = <HTMLInputElement>document.getElementById('company_name');

    const domain = <HTMLInputElement>event.target;
    const response = await fetch(`/api/check-corporation?email=${encodeURIComponent(domain.value)}`);

    if (response.status !== 200) {
        companyName.disabled = false;
        companyName.setAttribute('required', '');

        corporationSection.hidden = false;
        return;
    }

    // Disabled inputs are not submitted, which tells the server the corporation exists.
    companyName.disabled = true;
    companyName.removeAttribute('required');

    corporationSection.hidden = true;
})
